import CadastroTemplates from "../CadastrarTemplates";

const updateList = () => {};

export default function ConfigurarTemplates() {
    return (
        <div className="bg-white rounded p-2">
            <CadastroTemplates template={undefined} updateList={updateList} />
        </div>
    );
}
